<template>
    <div class="__addressing">
        <suggest-neighborhood-modal v-ref:suggest-neighborhood-modal :on-complete="neighborhoodAdded"></suggest-neighborhood-modal>
        <suggest-neighborhood-modal v-ref:suggest-alternative-neighborhood-modal :on-complete="alternativeNeighborhoodAdded"></suggest-neighborhood-modal>
        <div class="pseudo-form" v-bind:data-name="form">
            <div v-if="step === 'empty'">
                <div class="row">
                    <div class="col-xs-3">
                        <div class="form-group">
                            <label class="form-label">Modo de busca</label>
                            <select class="form-control" v-model="mode">
                                <option v-for="mode in options.modes" :value="mode.id">{{ mode.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="mode === 'cep'" class="col-xs-4">
                        <form-remote-select placeholder="Busque por CEP"
                                            url="/locations/addresses"
                                            :min="8"
                                            :template-result="formatAddress"
                                            :allow-empty="false"
                                            :on-change="searchZipcodeSelected">
                            <slot slot="label">Busque por CEP</slot>
                        </form-remote-select>
                    </div>
                    <div v-if="mode === 'street'" class="col-xs-2">
                        <form-select label="Estado"
                                     :model.sync="search.state_id"
                                     :options="searchOptions.states"
                                     identifier="id"
                                     :allow-empty="false"
                                     :on-change="searchStreetStateChanged"></form-select>
                    </div>
                    <div v-if="mode === 'street'" class="col-xs-2">
                        <form-select label="Cidade"
                                     identifier="id"
                                     :model.sync="search.city_id"
                                     :placeholder="searchStreetCityPlaceholder"
                                     :options="searchOptions.cities"
                                     :sorter="sortResults"
                                     :allow-empty="false"
                                     :disabled="searchStreetCityDisabled"
                                     :on-change="searchStreetCityChanged"></form-select>
                    </div>
                    <div v-if="mode === 'street'" class="col-xs-2">
                        <form-select label="Bairro"
                                     v-ref:neighborhood
                                     identifier="id"
                                     :model.sync="search.neighborhood_id"
                                     :placeholder="searchStreetNeighborhoodPlaceholder"
                                     :options="searchOptions.neighborhoods"
                                     :sorter="sortResults"
                                     :allow-empty="true"
                                     :disabled="searchStreetNeighborhoodDisabled"
                                     :on-change="searchStreetNeighborhoodChanged"></form-select>
                    </div>
                    <div v-if="mode === 'street'" class="col-xs-4">
                        <form-remote-select v-ref:search-street-street
                                            placeholder="Endereço"
                                            url="/locations/addresses"
                                            :query="search"
                                            :template-result="formatAddress"
                                            :placeholder="searchStreetStreetPlaceholder" :allow-empty="false"
                                            :disabled="!search.city_id" :on-change="searchZipcodeSelected">
                            <slot slot="label">
                                <span>Endereço</span>
                                <i v-if="search.fallback_zipcode"
                                   title="Incluíra também endereços parciais, que serão relacionados com o CEP Único da cidade."
                                   class="fa fa-exclamation-circle required-icon"
                                   v-tooltip></i>
                            </slot>
                        </form-remote-select>
                    </div>
                    <div v-if="model.zipcode && mode === 'cep'" class="col-xs-2 fake-label-margin">
                        <button @click="step = 'chosen'" class="btn btn-default">Cancelar</button>
                    </div>
                    <div v-if="model.zipcode && mode === 'street'" class="col-xs-2 fake-label-margin">
                        <button @click="step = 'chosen'" class="btn btn-default">Cancelar</button>
                    </div>
                </div>
            </div>
            <div v-if="step === 'chosen'">
                <div class="flex-row">
                    <div class="flex-col-2">
                        <form-mask mask="99999-999" placeholder="CEP" :model.sync="model.zipcode"
                                   :name="form + '.zipcode'" :disabled="true">
                            <slot slot="label">
                                CEP
                                <form-required :state="isRequired('zipcode')"></form-required>
                                <a href="javascript:;" @click="step = 'empty'" class="pull-right">Mudar CEP</a>
                                <div class="clearfix"></div>
                            </slot>
                        </form-mask>
                    </div>
                    <div class="flex-col-3">
                        <form-text :model.sync="stateName" placeholder="Estado" :disabled="true"
                                   :name="form + '.state_id'">
                            <slot slot="label">
                                Estado
                                <form-required :state="isRequired('state_id')"></form-required>
                            </slot>
                        </form-text>
                    </div>
                    <div class="flex-col-3">
                        <form-text :model.sync="cityName" placeholder="Cidade" :disabled="true"
                                   :name="form + '.city_id'">
                            <slot slot="label">
                                Cidade
                                <form-required :state="isRequired('city_id')"></form-required>
                            </slot>
                        </form-text>
                    </div>
                    <div class="flex-col-3">
                        <form-text v-if="ui.autoNeighborhood" :model.sync="neighborhoodName" placeholder="Bairro"
                                   :disabled="true" :name="form + '.neighborhood_id'">
                            <slot slot="label">
                                Bairro
                                <form-required :state="isRequired('neighborhood_id')"></form-required>
                            </slot>
                        </form-text>
                        <form-select v-if="!ui.autoNeighborhood"
                                     v-ref:auto-neighborhood
                                     placeholder="Bairro"
                                     :model.sync="model.neighborhood_id"
                                     :options.sync="options.neighborhoods"
                                     :allow-empty="false"
                                     :sorter="sortResults"
                                     :disabled="options.neighborhoods.length < 1"
                                     :template-result="formatNeighborhood"
                                     :process-result="processNeighborhoods"
                                     :name="form + '.neighborhood_id'"
                                     :on-change="neighborhoodChanged">
                            <slot slot="label">
                                Bairro
                                <form-required :state="isRequired('neighborhood_id')"></form-required>
                            </slot>
                        </form-select>
                    </div>
                    <div v-if="withAlternativeNeighborhood" class="flex-col-3">
                        <form-select v-ref:alternative-neighborhood
                                     placeholder="Bairro"
                                     :model.sync="model.alternative_neighborhood_id"
                                     :on-change="alternativeNeighborhoodChanged"
                                     :options.sync="options.neighborhoods"
                                     :allow-empty="false"
                                     :sorter="sortResults"
                                     :disabled="options.neighborhoods.length < 1"
                                     :template-result="formatAlternativeNeighborhood"
                                     :process-result="processNeighborhoods"
                                     :name="form + '.alternative_neighborhood_id'">
                            <slot slot="label">
                                Bairro comercial
                                <form-required :state="isRequired('alternative_neighborhood_id')"></form-required>
                            </slot>
                        </form-select>
                    </div>
                </div>
                <div class="flex-row">
                    <div class="flex-col-3">
                        <div style="position: relative" class="form-group">
                            <div style="position: absolute; right: 12px; bottom: 6px; cursor: pointer"
                                 v-if="hasDivergentStreet">
                                <i v-tooltip :vtitle="divergentStreetTitle"
                                   style="font-size: 18px; line-height: 18px;"
                                   @click="fixStreet"
                                   class="fa fa-question-circle font-orange"></i>
                            </div>
                            <form-text v-ref:street
                                       :model.sync="model.street"
                                       placeholder="Logradouro"
                                       :name="form + '.street'">
                                <slot slot="label">
                                    Endereço
                                    <form-required :state="isRequired('street')"></form-required>
                                </slot>
                            </form-text>
                        </div>
                    </div>
                    <div class="flex-col-2">
                        <div class="form-group">
                            <form-text :model.sync="model.street_number"
                                       :name="form + '.street_number'">
                                <slot slot="label">
                                    Número
                                    <form-required :state="isRequired('street_number')"></form-required>
                                </slot>
                            </form-text>
                        </div>
                    </div>
                    <div class="flex-col-2">
                        <div class="form-group">
                            <form-text :model.sync="model.portal_street_number"
                                       :name="form + '.portal_street_number'">
                                <slot slot="label">
                                    Número Portal
                                </slot>
                            </form-text>
                        </div>
                    </div>
                    <div v-if="withBlock" class="flex-col-2">
                        <div class="form-group">
                            <form-text :model.sync="model.block"
                                       :name="form + '.block'">
                                <slot slot="label">
                                    Bloco
                                    <form-required :state="isRequired('block')"></form-required>
                                </slot>
                            </form-text>
                        </div>
                    </div>
                    <div v-if="withComplementary" class="flex-col-2">
                        <div class="form-group">
                            <form-text :model.sync="model.complementary"
                                       :name="form + '.complementary'">
                                <slot slot="label">
                                    Complemento
                                    <form-required :state="isRequired('complementary')"></form-required>
                                </slot>
                            </form-text>
                        </div>
                    </div>
                    <div class="flex-col-1">
                        <div class="form-group">
                            <form-text :model.sync="model.zone"
                                       :name="form + '.zone'">
                                <slot slot="label">
                                    Zona
                                    <form-required :state="isRequired('zone')"></form-required>
                                </slot>
                            </form-text>
                        </div>
                    </div>
                </div>
                <div class="flex-row" style="width: 50%" v-if="withLandFields">
                    <div class="flex-col-3">
                        <form-text :model.sync="model.land_block"
                                   :name="form + '.land_block'">
                            <slot slot="label">
                                Quadra
                                <form-required :state="isRequired('land_block')"></form-required>
                            </slot>
                        </form-text>
                    </div>
                    <div class="flex-col-3">
                        <form-text :model.sync="model.land_allotment"
                                   :name="form + '.land_allotment'">
                            <slot slot="label">
                                Lote
                                <form-required :state="isRequired('land_allotment')"></form-required>
                            </slot>
                        </form-text>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div style="margin-top:-6px;" class="col-md-12">
                <div class="form-group hide-if-no-error">
                    <div :data-field="form + '.location'" tabindex="0" class="loud-error"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    .__addressing {
        .select2-container--bootstrap {
            .select2-results__option[aria-disabled=true].new-neighborhood-option {
                cursor: pointer;
            }
        }
    }
</style>

<script>
    const R = require('ramda')
    const { client, vueChaos } = require('sci/helpers')
    const $ = require('jquery')

    const isFilled = R.pipe(
        R.props(['zipcode', 'city', 'street']),
        R.none(R.isNil)
    )

    export default {
        components: {
            SuggestNeighborhoodModal: require('./SuggestNeighborhoodModal.vue')
        },
        props: {
            requiredFields: {
                type: Array,
                default: () => ['street', 'street_number', 'zipcode', 'state_id', 'city_id', 'neighborhood_id']
            },
            model: {
                twoWay: true
            },
            onZipcodeSelected: {
                type: Function,
                default: null
            },
            required: {
                type: Boolean,
                default: false
            },
            form: {
                type: String,
                default: null
            },
            mode: {
                type: String,
                default: 'cep'
            },
            withAlternativeNeighborhood: {
                type: Boolean,
                default: false
            },
            withZone: {
                type: Boolean,
                default: false
            },
            withBlock: {
                type: Boolean,
                default: true
            },
            withComplementary: {
                type: Boolean,
                default: true
            },
            withLandFields: {
                type: Boolean,
                default: false
            }
        },
        name: 'addressing',
        ready () {
            if (!this.form) {
                this.form = this._props.model.raw
            }

            if (isFilled(this.model)) {
                this.step = 'chosen'
                this.neighborhoodsLookup(true)
            }

            if (this.step === 'empty' && this.mode === 'street') {
                this.searchCities()
            }

            // this.$refs.suggestModal.show()
            // this.$refs.suggestNeighborhoodModal.show('Teste')
        },
        data () {
            return {
                zipcode: null,
                cityName: null,
                stateName: null,
                options: {
                    neighborhoods: [],
                    modes: [
                        { id: 'cep', name: 'Eu sei o CEP' },
                        { id: 'street', name: 'Eu não sei o CEP' }
                    ],
                    streetTypes: [
                        { name: 'Aeroporto' },
                        { name: 'Alameda' },
                        { name: 'Área' },
                        { name: 'Avenida' },
                        { name: 'Campo' },
                        { name: 'Chácara' },
                        { name: 'Colônia' },
                        { name: 'Condomínio' },
                        { name: 'Conjunto' },
                        { name: 'Distrito' },
                        { name: 'Esplanada' },
                        { name: 'Estação' },
                        { name: 'Estrada' },
                        { name: 'Favela' },
                        { name: 'Fazenda' },
                        { name: 'Feira' },
                        { name: 'Jardim' },
                        { name: 'Ladeira' },
                        { name: 'Lago' },
                        { name: 'Lagoa' },
                        { name: 'Largo' },
                        { name: 'Loteamento' },
                        { name: 'Morro' },
                        { name: 'Núcleo' },
                        { name: 'Parque' },
                        { name: 'Passarela' },
                        { name: 'Pátio' },
                        { name: 'Praça' },
                        { name: 'Quadra' },
                        { name: 'Recanto' },
                        { name: 'Residencial' },
                        { name: 'Rodovia' },
                        { name: 'Rua' },
                        { name: 'Setor' },
                        { name: 'Sítio' },
                        { name: 'Travessa' },
                        { name: 'Trecho' },
                        { name: 'Trevo' },
                        { name: 'Vale' },
                        { name: 'Vereda' },
                        { name: 'Via' },
                        { name: 'Viaduto' },
                        { name: 'Viela' },
                        { name: 'Vila' }
                    ]
                },
                step: 'empty',
                searchOptions: {
                    states: [
                        { id: 1, name: 'Acre', abbreviation: 'AC' },
                        { id: 2, name: 'Alagoas', abbreviation: 'AL' },
                        { id: 3, name: 'Amapá', abbreviation: 'AP' },
                        { id: 4, name: 'Amazonas', abbreviation: 'AM' },
                        { id: 5, name: 'Bahia', abbreviation: 'BA' },
                        { id: 6, name: 'Ceará', abbreviation: 'CE' },
                        { id: 7, name: 'Distrito Federal', abbreviation: 'DF' },
                        { id: 8, name: 'Espírito Santo', abbreviation: 'ES' },
                        { id: 9, name: 'Goiás', abbreviation: 'GO' },
                        { id: 10, name: 'Maranhão', abbreviation: 'MA' },
                        { id: 11, name: 'Mato Grosso', abbreviation: 'MT' },
                        { id: 12, name: 'Mato Grosso do Sul', abbreviation: 'MS' },
                        { id: 13, name: 'Minas Gerais', abbreviation: 'MG' },
                        { id: 14, name: 'Pará', abbreviation: 'PA' },
                        { id: 15, name: 'Paraíba', abbreviation: 'PB' },
                        { id: 16, name: 'Paraná', abbreviation: 'PR' },
                        { id: 17, name: 'Pernambuco', abbreviation: 'PE' },
                        { id: 18, name: 'Piauí', abbreviation: 'PI' },
                        { id: 19, name: 'Rio de Janeiro', abbreviation: 'RJ' },
                        { id: 20, name: 'Rio Grande do Norte', abbreviation: 'RN' },
                        { id: 21, name: 'Rio Grande do Sul', abbreviation: 'RS' },
                        { id: 22, name: 'Rondônia', abbreviation: 'RO' },
                        { id: 23, name: 'Roraima', abbreviation: 'RR' },
                        { id: 24, name: 'Santa Catarina', abbreviation: 'SC' },
                        { id: 25, name: 'São Paulo', abbreviation: 'SP' },
                        { id: 26, name: 'Sergipe', abbreviation: 'SE' },
                        { id: 27, name: 'Tocantins', abbreviation: 'TO' }
                    ],
                    cities: [],
                    neighborhoods: []
                },
                search: {
                    state_id: 25, // SP
                    city_id: null,
                    neighborhood_id: null,
                    fallback_zipcode: null
                },
                ui: {
                    loadingCities: false,
                    autoNeighborhood: false,
                    city: null
                }
            }
        },
        computed: {
            cityName () {
                return this.model.city ? this.model.city.name : ''
            },
            stateName () {
                return this.model.state ? this.model.state.name : ''
            },
            neighborhoodName () {
                return this.model.neighborhood ? this.model.neighborhood.name : ''
            },
            searchStreetCityDisabled () {
                return this.ui.loadingCities ||
                    !this.search.state_id ||
                    this.searchOptions.cities.length < 1
            },
            searchStreetNeighborhoodDisabled () {
                return this.ui.loadingNeighborhoods ||
                    !this.search.city_id ||
                    this.searchOptions.neighborhoods.length < 1
            },
            searchStreetCityPlaceholder () {
                if (!this.search.state_id) {
                    return 'Escolha o Estado'
                }

                if (this.ui.loadingCities || this.searchOptions.cities.length < 1) {
                    return 'Carregando...'
                }

                return 'Cidade'
            },
            searchStreetNeighborhoodPlaceholder () {
                if (!this.search.city_id) {
                    return 'Escolha a Cidade'
                }

                if (this.ui.loadingNeighborhoods || this.searchOptions.neighborhoods.length < 1) {
                    return 'Carregando...'
                }

                return 'Bairro'
            },
            searchStreetStreetPlaceholder () {
                if (!this.search.city_id) {
                    return 'Escolha a cidade'
                }

                return 'Busque o endereço'
            },
            hasDivergentStreet () {
                return this.zipcode &&
                    this.zipcode.address &&
                    this.model.street !== this.zipcode.address.name
            },
            divergentStreetTitle () {
                if (this.hasDivergentStreet) {
                    return `Esse endereço é diferente do endereço do CEP, clique para consertar<br /><br />Sugestão: ${this.zipcode.address.name}`
                }

                return 'Esse endereço é diferente do endereço do CEP'
            }
        },
        watch: {
            mode () {
                if (this.step === 'empty' && this.mode === 'street') {
                    this.searchCities()
                }
            },
            'search.city_id' () {
                this.$refs.searchStreetStreet.reload()

                if (this.step === 'empty' && this.mode === 'street') {
                    this.searchNeighborhoods()
                }
            },
            'ui.city' (newVal) {
                if (newVal && newVal.zipcode) {
                    this.search.fallback_zipcode = newVal.zipcode || null
                } else {
                    this.search.fallback_zipcode = null
                }
            },
            'model.zipcode' (newVal, oldVal) {
                if (newVal) {
                    this.step = 'chosen'
                    if (newVal !== oldVal) {
                        this.$nextTick(() => this.neighborhoodsLookup())
                    }
                } else {
                    this.step = 'empty'
                }
            }
        },
        methods: {
            sortResults(results) {
                 results.sort( (a,b) => {
                     if (a.text === undefined || a.text === null || a.id < 0) {
                         return 1;
                     }

                     if (b.text === undefined || b.text === null || b.id < 0) {
                         return -1;
                     }

                     return a.text.length - b.text.length
                 })
                return results
            },
            searchNeighborhoods () {
                if (this.ui.loadingNeighborhoods) {
                    return
                }

                this.ui.loadingNeighborhoods = true

                client
                    .silent()
                    .post('Carregando...', '/locations/neighborhoods', {
                        city_id: this.search.city_id,
                        per_page: 'max'
                    })
                    .then((res) => {
                        this.searchOptions.neighborhoods = res.data

                        this.ui.loadingNeighborhoods = false
                    })
            },
            neighborhoodAdded (neighborhood) {
                this.neighborhoodsLookup().then(() => {
                    this.model.neighborhood = neighborhood
                    this.model.neighborhood_id = neighborhood.id
                })
            },
            alternativeNeighborhoodAdded (neighborhood) {
                this.neighborhoodsLookup().then(() => {
                    this.model.alternative_neighborhood = neighborhood
                    this.model.alternative_neighborhood_id = neighborhood.id
                })
            },
            alternativeNeighborhoodChanged (id, info) {
                this.model.alternative_neighborhood = info
            },
            neighborhoodChanged (id, info) {
                this.model.neighborhood = info
            },
            searchStreetCityChanged (name, info) {
                this.ui.city = info

                this.$refs.searchStreetStreet.reload()
            },
            searchStreetNeighborhoodChanged (name, info) {
                this.ui.neighborhood = info

                this.$refs.searchStreetStreet.reload()
            },
            searchStreetStateChanged (id, info) {
                this.search.state_id = id

                this.searchCities()
            },
            searchCities () {
                this.ui.loadingCities = true

                client
                    .silent()
                    .post('Carregando...', '/locations/cities', {
                        state_id: this.search.state_id,
                        per_page: 'max'
                    })
                    .then((res) => {
                        this.ui.loadingCities = false

                        this.searchOptions.cities = res.data
                        this.ui.city = R.head(res.data)
                        this.search.city_id = R.head(res.data).id
                    })
            },
            searchZipcodeSelected (id, info) {
                this.step = 'chosen'

                this.model.zipcode = info.zipcode

                this.model.neighborhood = info.neighborhood
                this.model.neighborhood_id = info.neighborhood_id

                this.model.alternative_neighborhood = info.neighborhood
                this.model.alternative_neighborhood_id = info.neighborhood_id

                if (info.neighborhood) {
                    const city = info.neighborhood.city

                    this.model.city = city
                    this.model.city_id = city.id

                    this.model.state = city.state
                    this.model.state_id = city.state_id
                }

                if (info.name) {
                    this.model.street = info.name
                }

                this.neighborhoodsLookup(true).then(() => {
                    this.$refs.street.focus()
                })
            },
            formatAddress (state) {
                let prefix = ''

                if (state.generic && state.name) {
                    prefix = 'CEP Único - '
                } else if (state.generic) {
                    prefix = '<b>CEP Único</b>'
                }

                return `
                    <div>
                        <div>${prefix}<b>${state.name}</b></div>
                        <div style="font-size: 11px">${state.neighborhood.name}</div>
                        <div style="font-size: 11px">${state.neighborhood.city.name} - ${state.neighborhood.city.state.name}</div>
                        <div style="font-style: italic; font-size: 11px">${state.zipcode_formatted}</div>
                    </div>
                `
            },
            processNeighborhoods (result, term) {
                // if (result.length > 0) {
                //     return result
                // }

                return result.filter(_ => _.id !== -1).concat({
                    id: -1,
                    disabled: true,
                    __create: true,
                    name: term
                })
            },
            _formatNeighborhood (state, container, ref) {
                if (!state) {
                    return null
                }

                if (state.__create) {
                    container.classList.add('bg-warning')
                    container.classList.add('new-neighborhood-option')

                    container.addEventListener('click', () => {
                        this.$refs.neighborhood && this.$refs.neighborhood.close()
                        this.$refs.autoNeighborhood && this.$refs.autoNeighborhood.close()
                        this.$refs.alternativeNeighborhood && this.$refs.alternativeNeighborhood.close()

                        this.$refs[ref].show(state.name, this.model.state_id, this.model.city_id)
                    })

                    let statement = 'BAIRRO'

                    if (state.name) {
                        statement = `<b>${state.name}</b>`
                    }

                    return `
                        <div style="padding: 6px; margin-left: -6px; margin-right: -6px; cursor: pointer">
                            Não encontrou o bairro?
                            <button class="btn btn-sm orange" style="margin-top: 4px">CADASTRAR ${statement}</button>
                        </div>
                    `
                }

                return state.name
            },
            formatNeighborhood (state, container) {
                return this._formatNeighborhood(state, container, 'suggestNeighborhoodModal')
            },
            formatAlternativeNeighborhood (state, container) {
                return this._formatNeighborhood(state, container, 'suggestAlternativeNeighborhoodModal')
            },
            neighborhoodsLookup (fillStreet = false) {
                if (!this.model.zipcode) {
                    return Promise.reject(new Error('CEP não preenchido'))
                }

                let zipcode = this.model.zipcode

                if (/[0-9]{8}/.test(zipcode)) {
                    zipcode = zipcode.replace(/^(.{5})/, '$1-')
                }

                if (!/[0-9]{5}-[0-9]{3}/.test(zipcode)) {
                    return Promise.reject(new Error('Formato inválido'))
                }

                const $block = $(this.$el)

                return client
                    .background()
                    .block($block)
                    .get('Procurando CEP...', `/locations/${zipcode}`)
                    .then(vueChaos($block))
                    .then((data) => {
                        this.zipcode = data

                        this.options.neighborhoods = data.neighborhoods
                        if (fillStreet) {
                            if (data.street) {
                                this.model.street = data.street.name
                                this.ui.autoNeighborhood = true
                            } else {
                                this.ui.autoNeighborhood = false
                            }
                        }
                    })
                    .catch(() => {
                        this.model.zipcode = null
                    })
            },
            fixStreet () {
                this.model.street = this.zipcode.address.name
            },
            isRequired (field) {
                return this.required && this.requiredFields.indexOf(field) > -1
            }
        }
    }
</script>



// WEBPACK FOOTER //
// Addressing.vue?7297e801